import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ViewTabImage from 'modules/common/components/ViewTabImage';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
// import RejectModal from '../components/RejectModal';
import VerifyReceipt from './VerifyReceipt';
import * as action from './action';
import * as c from './constant';
// import GenerateSOA from './components/GenerateSOA';
import ViewSOA from './components/ViewSOA';
import ViewOR from './components/ViewOR';
import ViewPermit from './components/ViewPermit';
import ShowTransactionInfo from './components/ShowTransactionInfo';
import DeleteModal from './components/DeleteModal';
import FetchModal from './components/FetchModal';
import UpdateModal from './components/UpdateModal';
import AddRemarksModal from './components/AddRemarksModal';
import Location from './components/Location';

function TransactionContent({
  transactionInfo,
  taxpayerProfile,
  showTransaction,
  isAssessting,
  approveTransaction,
  rejectTransaction,
  clearTransaction,
  startAssessment,
  receiveTransaction,
  isLoading,
  match,
  reComputeTransaction,
  revokeTransaction,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const showVerifyReceipt = status => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleFetch = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <FetchModal id={selectedTransaction} />,
      title: 'Fetch Record',
      modalSize: 'modal-md',
    });
  };

  const handleViewSOA = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewSOA data={transactionInfo} id={selectedTransaction} />,
      title: `View eSOA`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOR data={transactionInfo} id={selectedTransaction} />,
      title: `View eOR`,
      modalSize: 'modal-xl',
    });
  };

  const handleRevoke = (id, remarks) => {
    revokeTransaction(id, { remarks }, () => {
      showTransaction(selectedTransaction);
    });
  };

  const handleViewPermit = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewPermit id={selectedTransaction} onRevoke={handleRevoke} />,
      title: `View ePermit`,
      modalSize: 'modal-xl',
    });
  };

  // const handleGenerateSOA = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <GenerateSOA data={transactionInfo} id={selectedTransaction} />,
  //     title: `Generate SOA`,
  //     modalSize: 'modal-lg',
  //   });
  // };

  const handleReject = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      remarks => {
        rejectTransaction(
          selectedTransaction,
          {
            remarks,
            status: 'FOR RESUBMISSION',
            module_type: 'BPLSR',
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleApprove = e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to approve this transaction?',
      remarks => {
        approveTransaction(
          selectedTransaction,
          {
            remarks,
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReceive = e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to tag as received this transaction?',
      remarks => {
        startAssessment(selectedTransaction, () => {
          receiveTransaction(
            selectedTransaction,
            {
              remarks,
              module_type: 'BPLSR',
            },
            () => {
              showTransaction(selectedTransaction);
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const onStartAssessment = () => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const getInitials = cString => {
    if (
      (cString >= 'A' && cString <= 'Z') ||
      (cString >= 'a' && cString <= 'z') ||
      cString === 'ñ' ||
      cString === 'Ñ'
    ) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return cString;
  };

  function RenderSOA() {
    if (!Acl(permissions, ['BPLS VIEW E-SOA'])) return null;

    if (_.get(transactionInfo, 'attributes.soa_generated_at')) {
      return (
        <>
          &nbsp;
          <button
            onClick={handleViewSOA}
            className="btn gen-btn btn-primary cms-bg-color-primary btn-round font-weight-bold mr-2"
            type="button"
          >
            View SOA
          </button>
        </>
      );
    }
    return '';
  }

  function RenderOR() {
    if (!Acl(permissions, ['BPLS VIEW E-OR'])) return null;

    if (_.get(transactionInfo, 'attributes.soa_generated_at')) {
      return (
        <>
          &nbsp;
          <button
            onClick={handleViewOR}
            className="btn gen-btn btn-primary cms-bg-color-primary btn-round font-weight-bold mr-2"
            type="button"
          >
            View OR
          </button>
        </>
      );
    }
    return '';
  }

  function RenderPermit() {
    if (!Acl(permissions, ['BPLS VIEW E-PERMIT'])) return null;

    if (_.get(transactionInfo, 'attributes.soa_generated_at')) {
      return (
        <>
          &nbsp;
          <button
            onClick={handleViewPermit}
            className="btn gen-btn btn-primary cms-bg-color-primary btn-round font-weight-bold mr-2"
            type="button"
          >
            View Permit
          </button>
        </>
      );
    }
    return '';
  }

  const handleOnRecompute = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want recompute this transaction?`,
      () => {
        reComputeTransaction(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.included.module.attributes}
          id={data.id}
        />
      ),
      title: `Update Information`,
      modalSize: 'modal-lg',
    });
  };

  const handleAdd = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddRemarksModal
          updateList={data.included.module.attributes}
          id={data.id}
        />
      ),
      title: `Add Business Remarks`,
      modalSize: 'modal-lg',
    });
  };

  const handleDelete = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <DeleteModal data={transactionInfo} id={selectedTransaction} />,
      title: `Delete Transaction`,
      modalSize: 'modal-md',
    });
  };

  return (
    <React.Fragment>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="card">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-3">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-3">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(
                          _.get(
                            transactionInfo,
                            'included.module.attributes.business_name'
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {_.get(
                          transactionInfo,
                          'included.module.attributes.business_name'
                        ) || '--'}
                      </h1>
                    </div>
                    <div className="d-flex ml-auto">
                      {showVerifyReceipt(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) && (
                        <button
                          onClick={handleVerifyReceipt}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold mr-2"
                          type="button"
                        >
                          Assess Payment Receipt
                        </button>
                      )}
                      {['FOR CHECKING'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        _.get(
                          transactionInfo,
                          'included.module.attributes.status'
                        ) === 'PRINTED' &&
                        Acl(permissions, ['START ASSESSMENT BPLS']) && (
                          <button
                            disabled={isAssessting}
                            type="button"
                            onClick={onStartAssessment(transactionInfo)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold"
                          >
                            Start Assessment&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}
                      {['FOR DELIVERY'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        Acl(permissions, [
                          'TAG AS RECEIVE BPLS TRANSACTION',
                        ]) && (
                          <button
                            disabled={isAssessting}
                            type="button"
                            onClick={handleReceive}
                            className="btn btn-success btn-round font-weight-bold"
                          >
                            Tag as Received&nbsp;
                          </button>
                        )}
                      {['SYNCED'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 1 && (
                          <button
                            type="button"
                            onClick={handleApprove}
                            className="form-button btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold mr-2"
                          >
                            Approve&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}
                      {['FOR CHECKING'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 1 &&
                        Acl(permissions, ['REJECT BPLS TRANSACTION']) && (
                          <button
                            type="button"
                            onClick={handleReject}
                            className="form-button btn btn-danger btn-round font-weight-bold"
                          >
                            Reject&nbsp;
                            <i className="fas fa-times" />
                          </button>
                        )}
                      {['FOR CHECKING'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 1 &&
                        Acl(permissions, ['SYNC BPLS TRANSACTION']) && (
                          <button
                            type="button"
                            onClick={handleFetch}
                            className="form-button btn btn-primary cms-bg-color-primary btn-round font-weight-bold ml-2"
                          >
                            Sync&nbsp;
                          </button>
                        )}

                      {['FOR CHECKING', 'FOR RESUBMISSION', 'EXPIRED REFERENCE NUMBER'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        Acl(permissions, ['DELETE TRANSACTION']) && (
                          <button
                            type="button"
                            onClick={handleDelete}
                            className="form-button btn btn-danger btn-round font-weight-bold ml-2"
                          >
                            Delete Transaction
                          </button>
                        )}

                      {[
                        'PENDING',
                        'WAITING FOR PAYMENT',
                        'EXPIRED REFERENCE NUMBER',
                      ].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 && <RenderSOA />}
                      {_.get(transactionInfo, 'attributes.paid_at') &&
                        _.get(
                          transactionInfo,
                          'included.module.attributes.or_generated_at'
                        ) && <RenderOR />}
                      {_.get(transactionInfo, 'attributes.paid_at') &&
                        _.get(
                          transactionInfo,
                          'included.module.attributes.permit_generated_at'
                        ) && <RenderPermit />}
                      {_.get(transactionInfo, 'attributes.paid_at') === null &&
                        _.get(
                          transactionInfo,
                          'attributes.soa_generated_at'
                        ) !== null &&
                        Acl(permissions, ['RECOMPUTE BPLS TRANSACTION']) && (
                          <button
                            type="button"
                            onClick={handleOnRecompute}
                            className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold ml-2"
                          >
                            Recompute
                          </button>
                        )}
                    </div>
                  </div>

                  {/* ROW 2 */}
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Business</Tab>
                      <Tab>Requirements</Tab>
                      <Tab>Location</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayerProfile}
                        module="psa"
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3">
                        <div className="row justify-content-end mr-2 mb-2">
                          {_.get(
                            transactionInfo,
                            'attributes.is_start_assessment'
                          ) === 1 &&
                            Acl(permissions, ['UPDATE BPLS TRANSACTION']) && (
                              <button
                                disabled={isLoading}
                                type="button"
                                onClick={handleEdit(transactionInfo)}
                                className="btn btn-warning btn-round font-weight-bold"
                              >
                                {isLoading ? (
                                  <i className="fa fa-spin fa-spinner" />
                                ) : (
                                  <>Edit Information</>
                                )}
                              </button>
                            )}
                        </div>
                        <ShowTransactionInfo
                          transactionInfo={transactionInfo}
                          handleAdd={handleAdd}
                          isLoading={isLoading}
                        />
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className=" p-3">
                        <ViewTabImage
                          label="Requirements"
                          // data={dummyData}
                          // sdata={membershipTypes.map(x => ({ ...x, label: x.membership_type }))}
                          data={(
                            _.get(
                              transactionInfo,
                              'included.requirementFiles'
                            ) || []
                          ).map(x => ({
                            ...x,
                            id: x.id,
                            name: x.attributes._application_requirement,
                            content: x.attributes.url,
                          }))}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <Location
                        value={
                          _.get(
                            transactionInfo,
                            'included.module.attributes.pinned_geolocation'
                          ) || ''
                        }
                      />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

TransactionContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  receiveTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAssessting: PropTypes.bool.isRequired,
  reComputeTransaction: PropTypes.instanceOf(Function).isRequired,
  revokeTransaction: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isAssessting: _.get(api, 'loading', []).indexOf(c.START_ASSESSMENT) > -1,
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  // selectedTransaction: _.get(match, 'params.id') || '',
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(TransactionContent);
